import React from "react"

const CurrentPolicyDetailsContext = React.createContext({})

const { Provider, Consumer } = CurrentPolicyDetailsContext

export { Provider, Consumer, CurrentPolicyDetailsContext }
